/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MyProfileFormattedPhoneNumberPipe } from './pipes'

@NgModule({
  imports: [CommonModule],
  declarations: [MyProfileFormattedPhoneNumberPipe],
  exports: [MyProfileFormattedPhoneNumberPipe],
})
export class MyprofilePhoneUtilsModule {}
